import { parsePhoneNumberFromString } from "libphonenumber-js/min";
import { object, string } from "yup";

import { removeNonIntegersFromString } from "@/helpers/string-helpers";
import IUser, { IUserInput } from "@/interfaces/user.interface";
import { UserFormMessages } from "@/messages/users/user-form.messages";
import { UserStatus } from "@/types/user.types";

import { UserFormData } from "./types";

export const userFormNames: Record<keyof UserFormData, string> = {
  email: "email",
  confirmEmail: "confirmEmail",
  languageCode: "languageCode",
  name: "name",
  phone1: "phone1",
  phone2: "phone2",
  enableSoundNotification: "enableSoundNotification",
};

export const buildUserFormInitialData = (user?: IUser | null): UserFormData => {
  return {
    status: user?.status || UserStatus.Active,
    email: user?.email || "",
    confirmEmail: user?.email || "",
    languageCode: user?.languageCode || "PT-BR",
    name: user?.name || "",
    phone1: user?.phone1 || "55",
    phone2: user?.phone2 || "55",
    userProfile: user?.userProfile || [],
    enableSoundNotification: user?.enableSoundNotification ?? true,
  };
};

export const buildUserFormSchema = (messages: UserFormMessages) =>
  object().shape({
    email: string().email(messages.errorInvalidEmail).required(messages.errorRequiredEmail),
    name: string().required(messages.errorRequiredName),
    phone1: string()
      .test("is-valid-phone", messages.errorInvalidPhone, (value) => {
        const digits = (value || "").replace(/\D/g, "");
        if (!digits) return false;
        if (digits.length < 10) return true; // permite digitação sem travar
        const phone = parsePhoneNumberFromString(`+${digits}`);
        return Boolean(phone?.isValid());
      })
      .required(messages.errorRequiredPhone),

    phone2: string().test("is-valid-phone-2", messages.errorInvalidPhone, (value) => {
      const digits = (value || "").replace(/\D/g, "");
      if (!digits) return true; // phone2 opcional
      if (digits.length < 10) return true;
      const phone = parsePhoneNumberFromString(`+${digits}`);
      return Boolean(phone?.isValid());
    }),
  });

export const normalizeUserFormData = (formData: UserFormData): IUserInput => {
  const phone1 = removeNonIntegersFromString(formData.phone1);
  const phone2 = removeNonIntegersFromString(formData.phone2);
  const dataToSubmit = { ...formData, confirmEmail: undefined, phone1, phone2 };
  return dataToSubmit;
};
